module.exports = __webpack_public_path__ + "594bd19d234f3bebd00788c76ce3e9d1.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/greece.png
 ** module id = 656
 ** module chunks = 0
 **/